<template>
    <div>
        <app-template>
            <div class="tf-free">
                
                <!-- SKELETON -->
                <div v-if="loading" class="tf-free-body">
                    <div class="tf-sk-grid">
                        <div class="tf-sk" v-for="i in 8" :key="i"></div>
                    </div>
                </div>
                
                <div v-else class="tf-free-body">
                    
                    <!-- ── SECTION : CE MOIS ── -->
                    <div class="tf-free-section-label">Ce mois · {{ data.mois }}</div>
                    
                    <div class="tf-free-kpi-grid grid md:grid-cols-4 gap-6">
                        
                        <!-- CA -->
                        <div class="tf-kpi-card tf-kpi-card--accent">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Chiffre d'affaires HT</div>
                            <div class="tf-kpi-card__val">{{ fmtEuro(visible.ca_mois) }}</div>
                            <div class="tf-kpi-card__sub">Année en cours : <strong>{{ fmtEuro(visible.ca_annee) }}</strong></div>
                        </div>
                        
                        <!-- En attente -->
                        <div class="tf-kpi-card tf-kpi-card--warn">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Factures en attente</div>
                            <div class="tf-kpi-card__val">{{ fmtEuro(visible.ca_en_attente) }}</div>
                            <div class="tf-kpi-card__sub">À encaisser</div>
                        </div>
                        
                        <!-- Interventions mois -->
                        <div class="tf-kpi-card">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Interventions ce mois</div>
                            <div class="tf-kpi-card__val">{{ visible.nb_interv_mois }}</div>
                            <div class="tf-kpi-card__sub">Cette semaine : <strong>{{ visible.nb_interv_semaine }}</strong> · Aujourd'hui : <strong>{{ visible.nb_interv_today }}</strong></div>
                        </div>
                        
                        <!-- Taux complétion -->
                        <div class="tf-kpi-card">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Taux de complétion</div>
                            <div class="tf-kpi-card__val">{{ visible.taux_completion }}%</div>
                            <div class="tf-kpi-card__progress">
                                <div class="tf-kpi-card__progress-fill" :style="{ width: visible.taux_completion + '%', background: visible.taux_completion >= 80 ? '#22C55E' : visible.taux_completion >= 50 ? '#F59E0B' : '#EF4444' }"></div>
                            </div>
                            <div class="tf-kpi-card__sub">Interventions finalisées</div>
                        </div>
                        
                        <!-- Clients -->
                        <div class="tf-kpi-card">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Clients</div>
                            <div class="tf-kpi-card__val">{{ visible.nb_clients }}</div>
                            <div class="tf-kpi-card__sub">
                                <span class="tf-pill tf-pill--green">+{{ visible.nb_nouveaux_clients }} ce mois</span>
                            </div>
                        </div>
                        
                        <!-- MRR -->
                        <div class="tf-kpi-card tf-kpi-card--gold">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">MRR contrats</div>
                            <div class="tf-kpi-card__val">{{ fmtEuro(visible.mrr) }}</div>
                            <div class="tf-kpi-card__sub">{{ visible.nb_contrats_actifs }} contrat{{ visible.nb_contrats_actifs > 1 ? 's' : '' }} actif{{ visible.nb_contrats_actifs > 1 ? 's' : '' }}</div>
                        </div>
                        
                        <!-- Techniciens -->
                        <div class="tf-kpi-card">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="7" r="4"/><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Techniciens</div>
                            <div class="tf-kpi-card__val">{{ visible.nb_techniciens }}</div>
                            <div class="tf-kpi-card__sub">Comptes actifs</div>
                        </div>
                        
                        <!-- Ruptures stock -->
                        <div class="tf-kpi-card" :class="visible.nb_ruptures_stock > 0 ? 'tf-kpi-card--danger' : ''">
                            <div class="tf-kpi-card__icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
                            </div>
                            <div class="tf-kpi-card__lbl">Ruptures de stock</div>
                            <div class="tf-kpi-card__val">{{ visible.nb_ruptures_stock }}</div>
                            <div class="tf-kpi-card__sub">{{ visible.nb_ruptures_stock > 0 ? 'Produits épuisés' : 'Stock correct' }}</div>
                        </div>
                        
                    </div>
                    
                    <!-- ── HINTS TEASER ── -->
                    <div class="tf-free-section-label" style="margin-top:28px">
                        Ce que vous ne voyez pas encore
                        <span class="tf-lock-pill">
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                            Premium
                        </span>
                    </div>
                    
                    <div class="tf-hints-grid">
                        
                        <!-- Hint: meilleur technicien -->
                        <div class="tf-hint-card">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                                Performance techniciens
                            </div>
                            <div class="tf-hint-card__body" v-if="hints.meilleur_tech_nb > 0">
                                <div class="tf-hint-stat">Un de vos techniciens a réalisé <span class="tf-hint-number">{{ hints.meilleur_tech_nb }}</span> interventions ce mois.</div>
                                <div class="tf-hint-stat tf-hint-stat--low" v-if="hints.moins_actif_tech_nb > 0 && hints.moins_actif_tech_nb < hints.meilleur_tech_nb">
                                    Un autre n'en a réalisé que <span class="tf-hint-number tf-hint-number--warn">{{ hints.moins_actif_tech_nb }}</span>.
                                </div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block"></div>
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                    <div class="tf-blur-block"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__body" v-else>
                                <div class="tf-hint-stat">Aucune intervention enregistrée ce mois.</div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir le classement complet, les heures terrain, le CA par technicien et les absences →
                            </div>
                        </div>
                        
                        <!-- Hint: KM parcourus -->
                        <div class="tf-hint-card">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
                                Trajets & coûts
                            </div>
                            <div class="tf-hint-card__body">
                                <div class="tf-hint-stat">Vos techniciens ont parcouru <span class="tf-hint-number">{{ hints.km_total_mois }}</span> km ce mois.</div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                    <div class="tf-blur-block"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir le coût total des trajets, la distance moyenne par intervention et l'optimisation possible →
                            </div>
                        </div>
                        
                        <!-- Hint: conformité F-GAZ -->
                        <div class="tf-hint-card" v-if="hints.has_cerfas">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                                Conformité F-GAZ
                            </div>
                            <div class="tf-hint-card__body">
                                <div class="tf-hint-stat" v-if="hints.nb_fuites_detectees > 0">
                                    <span class="tf-hint-number tf-hint-number--warn">{{ hints.nb_fuites_detectees }}</span> fuite{{ hints.nb_fuites_detectees > 1 ? 's' : '' }} détectée{{ hints.nb_fuites_detectees > 1 ? 's' : '' }} cette année sur vos CERFAs.
                                </div>
                                <div class="tf-hint-stat" v-else>Vos CERFAs ne signalent aucune fuite cette année.</div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block"></div>
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                    <div class="tf-blur-block"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir le taux de conformité détaillé, les types d'interventions et le suivi bouteilles →
                            </div>
                        </div>
                        
                        <!-- Hint: absences -->
                        <!-- <div class="tf-hint-card">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                                Absences
                            </div>
                            <div class="tf-hint-card__body">
                                <div class="tf-hint-stat" v-if="hints.nb_absences_mois > 0">
                                    <span class="tf-hint-number tf-hint-number--warn">{{ hints.nb_absences_mois }}</span> absence{{ hints.nb_absences_mois > 1 ? 's' : '' }} enregistrée{{ hints.nb_absences_mois > 1 ? 's' : '' }} ce mois.
                                </div>
                                <div class="tf-hint-stat" v-else>Aucune absence enregistrée ce mois.</div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                    <div class="tf-blur-block"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir le détail par technicien, le type d'absence et les jours impactés →
                            </div>
                        </div> -->
                        
                        <!-- Hint: contrats expirant -->
                        <div class="tf-hint-card" :class="hints.contrats_expirent_30j > 0 ? 'tf-hint-card--urgent' : ''">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                                Contrats à renouveler
                            </div>
                            <div class="tf-hint-card__body">
                                <div class="tf-hint-stat" v-if="hints.contrats_expirent_30j > 0">
                                    <span class="tf-hint-number tf-hint-number--danger">{{ hints.contrats_expirent_30j }}</span> contrat{{ hints.contrats_expirent_30j > 1 ? 's' : '' }} expire{{ hints.contrats_expirent_30j > 1 ? 'nt' : '' }} dans 30 jours.
                                </div>
                                <div class="tf-hint-stat" v-else>Aucun contrat n'expire dans les 30 prochains jours.</div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block"></div>
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir lesquels, avec quel client, pour quel montant, et recevoir des alertes automatiques →
                            </div>
                        </div>
                        
                        <!-- Hint: finance avancée -->
                        <div class="tf-hint-card">
                            <div class="tf-hint-card__header">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                                Finance & rentabilité
                            </div>
                            <div class="tf-hint-card__body">
                                <div class="tf-hint-stat">CA annuel en cours : <span class="tf-hint-number">{{ fmtEuro(visible.ca_annee) }}</span></div>
                                <div class="tf-hint-blur-row">
                                    <div class="tf-blur-block"></div>
                                    <div class="tf-blur-block"></div>
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                </div>
                                <div class="tf-hint-blur-row" style="margin-top:6px">
                                    <div class="tf-blur-block tf-blur-block--sm"></div>
                                    <div class="tf-blur-block"></div>
                                </div>
                            </div>
                            <div class="tf-hint-card__footer">
                                Voir le DSO, les impayés > 30j, le top 10 clients, les commissions commerciales et le panier moyen →
                            </div>
                        </div>
                        
                    </div>
                    
                    <!-- ── BANNER UPGRADE ── -->
                    <div v-if="$account.account.societe.independant == 1" class="tf-upgrade-banner">
                        <div class="tf-upgrade-banner__left">
                            <div class="tf-upgrade-banner__title">
                                Vous voyez <strong>8 métriques</strong> sur <strong>60+</strong> disponibles.
                            </div>
                            <div class="tf-upgrade-banner__sub">
                                Le Dashboard Premium donne un pilotage complet : classement technicien par technicien, rentabilité par intervention, alertes automatiques, stock en temps réel, géographie clients et bien plus.
                            </div>
                        </div>
                        <button class="tf-upgrade-banner__btn" @click="goUpgrade">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                            Débloquer le Premium
                        </button>
                    </div>
                    
                </div><!-- /tf-free-body -->
            </div>
        </app-template>
    </div>
</template>

<script>
export default {
    name: 'DashboardFree',
    
    data() {
        return {
            loading: true,
            data:    {},
            visible: {},
            hints:   {},
        }
    },
    
    mounted() { this.load() },
    
    methods: {
        async load() {
            this.loading = true
            try {
                const data  = await this.$request.get('/dashboard/free')
                this.data    = data
                this.visible = data.visible || {}
                this.hints   = data.hints || {}
            } catch (e) {
                console.error('Dashboard free error', e)
            } finally {
                this.loading = false
            }
        },
        
        fmtEuro(v) {
            const n = parseFloat(v) || 0
            if (n >= 1e6) return (n / 1e6).toFixed(1) + ' M€'
            if (n >= 1e3) return (n / 1e3).toFixed(1) + ' k€'
            return n.toFixed(0) + ' €'
        },
        
        goUpgrade() {
            this.$router.push('/upgrade')
        },
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

.tf-free {
    --navy:    #1B2E4B;
    --gold:    #C9A84C;
    --gold-lt: #FDF6E3;
    --bg:      #F4F6FA;
    --surf:    #FFFFFF;
    --border:  #E2E8F2;
    --text:    #0F1C2E;
    --muted:   #7A8BA3;
    --green:   #22C55E;
    --warn:    #F59E0B;
    --danger:  #EF4444;
    --r:       12px;
    --sh:      0 2px 10px rgba(27,46,75,.06);
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    color: var(--text);
}

/* ── HEADER ── */
.tf-free-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 28px; height: 56px; background: var(--surf);
    border-bottom: 1px solid var(--border);
    position: sticky; top: 0; z-index: 100;
    box-shadow: 0 1px 0 var(--border), 0 3px 12px rgba(27,46,75,.04);
}
.tf-free-brand { display: flex; align-items: center; gap: 9px; }
.tf-free-brand__name { font-size: 15px; font-weight: 700; color: var(--navy); letter-spacing: -.3px; }
.tf-free-header__center { font-size: 13px; color: var(--muted); font-weight: 500; }
.tf-free-period { font-size: 13px; color: var(--muted); text-transform: capitalize; }
.tf-upgrade-btn {
    display: flex; align-items: center; gap: 7px;
    padding: 8px 16px; border-radius: 8px;
    background: var(--navy); color: white; border: none;
    font-size: 13px; font-weight: 600; cursor: pointer;
    transition: .15s; letter-spacing: -.1px;
}
.tf-upgrade-btn:hover { background: #243C62; }

/* ── BODY ── */
.tf-free-body { padding: 24px 28px 56px; }

/* ── SKELETON ── */
.tf-sk-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; }
.tf-sk { height: 116px; border-radius: var(--r); background: linear-gradient(90deg, #E8EDF3 25%, #F4F6FA 50%, #E8EDF3 75%); background-size: 200% 100%; animation: sk 1.4s infinite; }
@keyframes sk { to { background-position: -200% 0; } }

/* ── SECTION LABEL ── */
.tf-free-section-label {
    display: flex; align-items: center; gap: 10px;
    font-size: 11px; font-weight: 700; text-transform: uppercase;
    letter-spacing: 1px; color: var(--muted); margin-bottom: 14px;
}
.tf-lock-pill {
    display: inline-flex; align-items: center; gap: 5px;
    background: var(--gold-lt); color: var(--gold);
    border: 1px solid rgba(201,168,76,.3); border-radius: 20px;
    font-size: 10px; font-weight: 700; padding: 2px 9px;
    text-transform: uppercase; letter-spacing: .5px;
}

/* ── KPI GRID ── */
.tf-kpi-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; }

.tf-kpi-card {
    background: var(--surf); border: 1px solid var(--border);
    border-radius: var(--r); padding: 18px 20px;
    box-shadow: var(--sh); transition: .18s;
    display: flex; flex-direction: column; gap: 4px;
    position: relative; overflow: hidden;
}
.tf-kpi-card:hover { box-shadow: 0 6px 28px rgba(27,46,75,.10); transform: translateY(-1px); }

.tf-kpi-card--accent { background: var(--navy); border-color: var(--navy); }
.tf-kpi-card--accent .tf-kpi-card__icon,
.tf-kpi-card--accent .tf-kpi-card__lbl,
.tf-kpi-card--accent .tf-kpi-card__val,
.tf-kpi-card--accent .tf-kpi-card__sub { color: rgba(255,255,255,.85); }
.tf-kpi-card--accent::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: var(--gold); }

.tf-kpi-card--gold { background: var(--gold-lt); border-color: rgba(201,168,76,.3); }
.tf-kpi-card--gold .tf-kpi-card__val { color: var(--gold); }

.tf-kpi-card--warn  { border-left: 3px solid var(--warn); }
.tf-kpi-card--danger { border-left: 3px solid var(--danger); }
.tf-kpi-card--danger .tf-kpi-card__val { color: var(--danger); }

.tf-kpi-card__icon  { color: var(--muted); margin-bottom: 6px; }
.tf-kpi-card__lbl   { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .4px; color: var(--muted); }
.tf-kpi-card__val   { font-size: 28px; font-weight: 700; color: var(--navy); letter-spacing: -1.2px; font-family: 'DM Mono', monospace; line-height: 1; margin: 4px 0; }
.tf-kpi-card__sub   { font-size: 11.5px; color: var(--muted); }
.tf-kpi-card__progress { height: 4px; background: rgba(0,0,0,.08); border-radius: 2px; margin: 6px 0 2px; overflow: hidden; }
.tf-kpi-card__progress-fill { height: 100%; border-radius: 2px; transition: width .6s cubic-bezier(.4,0,.2,1); }

/* ── PILLS ── */
.tf-pill { display: inline-flex; align-items: center; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 4px; }
.tf-pill--green { background: #F0FDF4; color: #15803D; }

/* ── HINTS GRID ── */
.tf-hints-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }

.tf-hint-card {
    background: var(--surf); border: 1px solid var(--border);
    border-radius: var(--r); overflow: hidden;
    box-shadow: var(--sh); display: flex; flex-direction: column;
    transition: .18s;
}
.tf-hint-card:hover { box-shadow: 0 6px 28px rgba(27,46,75,.10); }
.tf-hint-card--urgent { border-color: rgba(239,68,68,.4); }

.tf-hint-card__header {
    display: flex; align-items: center; gap: 8px;
    padding: 13px 16px 10px;
    font-size: 12px; font-weight: 700; color: var(--navy);
    border-bottom: 1px solid var(--border);
    background: var(--bg);
}
.tf-hint-card__body { padding: 14px 16px; flex: 1; }

.tf-hint-stat { font-size: 13px; color: var(--text); line-height: 1.5; margin-bottom: 8px; }
.tf-hint-stat--low { color: var(--muted); font-size: 12px; }
.tf-hint-number { font-family: 'DM Mono', monospace; font-weight: 700; font-size: 15px; color: var(--navy); }
.tf-hint-number--warn   { color: var(--warn); }
.tf-hint-number--danger { color: var(--danger); }

/* ── BLURRED FAKE DATA ── */
.tf-hint-blur-row { display: flex; gap: 8px; margin-top: 10px; }
.tf-blur-block {
    height: 10px; background: var(--border); border-radius: 4px;
    flex: 1; filter: blur(3px); opacity: .7;
}
.tf-blur-block--sm { flex: 0.5; }

.tf-hint-card__footer {
    padding: 10px 16px 13px;
    font-size: 11.5px; color: var(--muted);
    border-top: 1px dashed var(--border);
    background: var(--bg);
    line-height: 1.4;
}

/* ── UPGRADE BANNER ── */
.tf-upgrade-banner {
    display: flex; align-items: center; justify-content: space-between; gap: 24px;
    margin-top: 24px; padding: 24px 28px;
    background: var(--navy); border-radius: var(--r);
    box-shadow: 0 8px 32px rgba(27,46,75,.18);
}
.tf-upgrade-banner__title { font-size: 16px; font-weight: 600; color: white; margin-bottom: 6px; }
.tf-upgrade-banner__title strong { color: var(--gold); }
.tf-upgrade-banner__sub { font-size: 13px; color: rgba(255,255,255,.6); line-height: 1.5; max-width: 600px; }
.tf-upgrade-banner__btn {
    display: flex; align-items: center; gap: 8px; white-space: nowrap; flex-shrink: 0;
    padding: 12px 24px; border-radius: 10px;
    background: var(--gold); color: var(--navy); border: none;
    font-size: 14px; font-weight: 700; cursor: pointer; transition: .15s;
}
.tf-upgrade-banner__btn:hover { background: #d4b560; transform: translateY(-1px); }

/* ── RESPONSIVE ── */
@media (max-width: 1200px) {
    .tf-kpi-grid   { grid-template-columns: repeat(2, 1fr); }
    .tf-hints-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 768px) {
    .tf-free-body  { padding: 14px 14px 40px; }
    .tf-kpi-grid   { grid-template-columns: 1fr; }
    .tf-hints-grid { grid-template-columns: 1fr; }
    .tf-free-header { padding: 0 14px; }
    .tf-upgrade-banner { flex-direction: column; text-align: center; }
    .tf-upgrade-banner__btn { width: 100%; justify-content: center; }
}
</style>